import type { NextPage } from "next";
import React, { useEffect, useState } from "react";
import { Game } from "../components/game";
import { GetAuth } from "../lib/auth";
import { useRouter } from "next/router";
import { Pages } from "../lib/pages";
import { ContainerWhite } from "../components/basic";
import { LoadingCenter } from "../components/loading";
import Layout from "../components/layout";

const GamePage: NextPage = () => {
	const router = useRouter();
	const [loaded, setLoaded] = useState(false);

	useEffect(() => {
		if (GetAuth()) {
			setLoaded(true);
		} else {
			router.push(Pages.Login);
		}
	}, [router]);

	if (loaded) return <Game />;

	return (
		<Layout title="Hra">
			<ContainerWhite>
				<LoadingCenter />
			</ContainerWhite>
		</Layout>
	);
};

export default GamePage;
